<template>
  <div>
    <van-nav-bar title="入会指南" left-arrow @click-left="onClickLeft" />
    <div class="join">
      <img src="@/assets/images/join.png" />
      <div @click="onCall" class="call">
        <span>咨询热线:玉林市总工会{{ phoneNumber }}</span>
        <van-icon name="phone-circle" />
      </div>

      <van-dialog
        v-model="show"
        show-cancel-button
        confirm-button-text="拨打"
        @confirm="onFirmCall"
      >
        <div class="msg">是否拨打玉林市总工会咨询电话?</div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  name: 'join',
  data() {
    return {
      show: false,
      phoneNumber: '0775-2826902',
    };
  },
  created() {
    let title = '入会指南';
    if (this.$getUA() === 1) {
      this.$callApp('Android', 'onJSAppSetTitle', title); //调用安卓的设置标题方法
      this.$callApp('Android', 'SetWebViewZoom', true);
    } else if (this.$getUA() === 2) {
      this.$callApp('iOS', 'getWebViewTitleMethod', title); //调用IOS设置标题的方法
      this.$callApp('iOS', 'EnableWebZoomMethod', true);
    }
  },
  methods: {
    onFirmCall() {
      window.location.href = 'tel:' + this.phoneNumber;
    },
    onCall() {
      this.show = !this.show;
      // Dialog.confirm({
      //     width: "80%",
      //     cancelButtonText: "取消",
      //     confirmButtonText: "拨打",
      //     message: ' 是否拨打玉林市总工会咨询电话 '
      // }).then(() => {
      //     window.location.href = 'tel:' + this.phoneNumber
      // }).catch(() => {
      //     // on cancel
      // });
    },
    onClickLeft() {
      // this.$router.back(-1);
       this.$callApp('Android', 'GoBackAppMethod', '')
       this.$callApp('iOS', 'GoBackAppMethod', '')
    },
  },
};
</script>

<style lang="less" scoped>

.msg {
  text-align: center;
  padding: 25px 5px;
  font-size: 16px !important;
  width: 100%;
  line-height: 20px;
}

.join {
  padding: 2.5px 1px 0px 2.5px;
  background: linear-gradient(to bottom, #f6ae98, #ed7979);
  position: absolute;
  top: 0px;
  bottom: 0px;
}

img {
  width: 100%;
  margin-bottom: 10px;
}

.call {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.van-icon-phone-circle {
  font-size: 22.5px;
  animation: mymove 1s infinite;
  color: green;
}

.van-icon-phone-circle:active {
  font-size: 31px;
  color: #006000;
}

@keyframes mymove {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(30deg);
    transition: all 10s;
  }
}
</style>
